import SlideThumbnailSortable from './sortable';
import SlideThumbnail from './SlideThumbnail';

export { SlideThumbnail };

export default SlideThumbnailSortable;
